export default __webpack_public_path__ + "static/media/cucco.c2738362.wav";